// semeia-disable-reexport
import ModelRegistry from "@ember-data/types/registries/model";
import { dasherize } from "@ember/string";

/**
 * Compute the `fields` parameter of a JSON API request, using a model and a list of model attributes.
 *
 * The `fields` parameter tells the API to return only those fields.
 * `fields` is a list of JSON API attributes, with words separated by a dash (eg. "firstName" is "first-name").
 *
 * This function transforms a list of model attributes into a list of JSON API attributes suitable for the `fields` parameter.
 */
export function apiFieldset(model, attributes) {
  const type = `${dasherize(model)}s`;
  const fields = attributes.map(attribute => dasherize(attribute)).join(",");
  return {
    [type]: fields
  };
}